import { render } from "./Player.vue?vue&type=template&id=6c2fbbad&scoped=true"
import script from "./Player.vue?vue&type=script&lang=js"
export * from "./Player.vue?vue&type=script&lang=js"

import "./Player.vue?vue&type=style&index=0&id=6c2fbbad&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-6c2fbbad"

export default script